import { render, staticRenderFns } from "./sys.settings.vue?vue&type=template&id=167be703&"
import script from "./sys.settings.vue?vue&type=script&lang=js&"
export * from "./sys.settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports